import * as React from 'react';

const ScalableText: React.FC<React.PropsWithChildren> = ({children}) => (
    <svg className="scalable-text" viewBox="0 0 100 100">
        <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle">
            {children}
        </text>
    </svg>
);

export default ScalableText;
